/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { handleScroll } from '../utils';
// import styles from './index.css.js';
import log from '../logger';
import './index.css';
const POSITION_TYPES = ['top left', 'top center', 'top right', 'right top', 'right center', 'right bottom', 'bottom left', 'bottom center', 'bottom right', 'left top', 'left center', 'left bottom', 'center center'];
export default class Popup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClickAway = e => {
      // log.trace('window clicked!!! e:', e);
      if (this.popupClick) this.popupClick = false;else if (!this.prompted) this.closePopup(e);
    };
    this.handleResize = () => {
      const {
        isOpen
      } = this.state;
      if (isOpen) this.setPosition();
    };
    this.handleTriggerClicked = e => {
      this.popupClick = true;
      // log.trace('trigger clicked!!!');
      // // const { on } = this.props;
      // // const openOnClick = on === 'click' || (Array.isArray(on) && on.includes('click'));
      // // if (openOnClick) this.togglePopup(e);
      // e.stopPropagation();
    };
    this.preventPopupClose = e => {
      // e.stopPropagation();
      this.popupClick = true;
    };
    this.setTriggerRef = r => {
      if (!r) return;
      const {
        closeOnClickAway,
        mountNode: mountNodeProp
      } = this.props;
      if (closeOnClickAway) {
        if (this.TriggerEl) this.TriggerEl.removeEventListener('click', this.handleTriggerClicked);
        window.removeEventListener('click', this.handleClickAway);
        r.addEventListener('click', this.handleTriggerClicked);
        window.addEventListener('click', this.handleClickAway);
      }
      this.TriggerEl = r;

      // let mountNode;
      // if (mountNodeProp) {
      //     if (mountNodeProp.current) mountNode = mountNodeProp.current;
      //     else if (mountNodeProp.nodeName) mountNode = mountNodeProp;
      // }
      // // if (mountNodeProp) log.trace('mountNodeProp:', mountNodeProp, 'mountNode:', mountNode);
      // this.setState({ mountNode: mountNode || this.TriggerEl.parentElement || document.body });

      // log.trace('TriggerEl ref:', r);
      // if (closeOnClickAway) {
      //     // this.TriggerEl.onClick = null;
      //     // r.removeEventListener('click', this.handleTriggerClicked);
      //     // r.addEventListener('click', this.handleTriggerClicked);
      // }
    };
    this.setArrowRef = r => {
      if (r) this.ArrowEl = r;
    };
    this.setContentRef = r => {
      // log.trace('content ref:', r);
      if (!r) return;
      this.ContentEl = r;
      // log.trace('ContentEl ref:', r);
      this.setPosition();
      // const { closeOnClickAway } = this.props;
      // if (closeOnClickAway) {
      //     window.removeEventListener('click', this.handleClickAway);
      //     r.removeEventListener('click', this.preventPopupClose);
      //     window.addEventListener('click', this.handleClickAway);
      //     r.addEventListener('click', this.preventPopupClose);
      // }
    };
    this.onEscape = e => {
      if (e.key === 'Escape') this.closePopup();
    };
    this.lockScroll = () => {
      const {
        lockScroll
      } = this.props;
      const {
        modal
      } = this.state;
      if (modal && lockScroll) {
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
      }
    };
    this.resetScroll = () => {
      const {
        lockScroll
      } = this.props;
      const {
        modal
      } = this.state;
      if (modal && lockScroll) {
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
      }
    };
    this.togglePopup = e => {
      // https://reactjs.org/docs/events.html#event-pooling
      if (e.persist) e.persist();
      if (this.state.isOpen) this.closePopup(e);else this.openPopup(e);
      // log.trace('stopping propagation... e:', e);
      // if (e.type === 'click') e.stopPropagation();
    };
    this.openPopup = e => {
      const {
        open,
        disabled,
        onOpen
      } = this.props;
      const {
        isOpen
      } = this.state;
      if (isOpen && !this.prompted || disabled) return;
      onOpen(e);
      /** Open state priority:
       *   1. this.prompted (if this.prompt() was called)
       *   2. this.props.open (let component remain controlled by open prop)
       *   3. default to true since openPopup was just called
       */
      const openComputed = this.prompted || (open !== undefined ? open : true);
      // log.trace('this.prompted:', this.prompted, 'openComputed:', openComputed, 'this.promptIndex:', this.promptIndex);

      this.setState({
        isOpen: openComputed
      }, () => {
        // this.setPosition(); // Call on ref initialization instead
        this.lockScroll();
      });
    };
    this.closePopup = e => {
      const {
        open,
        onClose
      } = this.props;
      const {
        isOpen
      } = this.state;
      if (!isOpen) return;
      onClose(e);
      const openComputed = this.prompted || (open !== undefined ? open : false);
      // log.trace('closePopup openComputed:', openComputed);
      this.setState({
        isOpen: openComputed,
        promptMessage: undefined
      }, this.resetScroll);
    };
    this.onMouseEnter = () => {
      clearTimeout(this.timeOut);
      const {
        mouseEnterDelay
      } = this.props;
      this.timeOut = setTimeout(() => {
        if (this.mounted) this.openPopup();
      }, mouseEnterDelay);
    };
    this.onMouseLeave = () => {
      clearTimeout(this.timeOut);
      const {
        mouseLeaveDelay
      } = this.props;
      this.timeOut = setTimeout(() => {
        if (this.mounted) this.closePopup();
      }, mouseLeaveDelay);
    };
    this.getTooltipBoundary = () => {
      const {
        keepTooltipInside
      } = this.props;
      let boundingBox = {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight
      };
      if (typeof keepTooltipInside === 'string') {
        const selector = document.querySelector(keepTooltipInside);
        if (process.env.NODE_ENV !== 'production' && selector === null) {
          throw new Error(keepTooltipInside.concat(' selector does not exist : keepTooltipInside must be a valid html selector \'class\' or \'Id\' or a boolean value'));
        }
        boundingBox = selector.getBoundingClientRect();
      }
      return boundingBox;
    };
    /* Algo to calculate position
    1. center position for popup content : the center of the trigger will be the center of the content content
        so the popup content position will be like this :
        top => the y of the center for the trigger element : trigger.top + trigger.height/2
        left => the x of the center for the trigger element : trigger.left + trigger.width/2
    2. translate position according to the first  position attribute  passed  in the function argument
        for example :
            position = 'left top'
            we need to handle the first argument in the position: 'left' => that's mean we need to
                translate the popup content according to the X axis by - content.width/2
    3.translate position according to the first  position attribute  passed  in the function argument
        for example :
        position = 'left top'
        the second argument 'top' => translate popup content by + content.height*4/5
    4. check if calculated position is going out of bounds of wrapper box or not. If yes
        repeat 1-3 for next position enum. By default wrapper box is window element
    */
    this.getCoordinatesForPosition = (triggerBounding, contentBounding, position, _ref, wrapperBox) => {
      let {
        offsetX,
        offsetY
      } = _ref;
      const [positionPrimary, positionSecondary] = position.split(' ');
      const CenterTop = triggerBounding.top + triggerBounding.height / 2;
      const CenterLeft = triggerBounding.left + triggerBounding.width / 2;
      const {
        height,
        width
      } = contentBounding;
      const arrowRadius = ((this.ArrowEl || {}).clientHeight || 0) / 2;
      const arrowMarginStart = 8;
      const arrowMarginEnd = 10; // Two greater than arrowMarginStart due to 1px border on each side
      let adjusted = 0;
      let top = CenterTop - height / 2;
      let left = CenterLeft - width / 2;
      const arrowPosition = {};
      let arrowShadow;
      switch (positionPrimary) {
        case 'top':
          top -= height / 2 + triggerBounding.height / 2 + arrowRadius + 2;
          arrowPosition.top = '100%';
          arrowShadow = '1px 1px';
          break;
        case 'bottom':
          top += height / 2 + triggerBounding.height / 2 + arrowRadius + 2;
          arrowPosition.top = '0%';
          arrowShadow = '-1px -1px';
          break;
        case 'left':
          left -= width / 2 + triggerBounding.width / 2 + arrowRadius + 2;
          arrowPosition.left = '100%';
          arrowShadow = '1px -1px';
          break;
        case 'right':
          left += width / 2 + triggerBounding.width / 2 + arrowRadius + 2;
          arrowPosition.left = '0%';
          arrowShadow = '-1px 1px';
          break;
        default:
      }
      switch (positionSecondary) {
        case 'top':
          top = triggerBounding.top;
          break;
        case 'bottom':
          top = triggerBounding.top - height + triggerBounding.height;
          break;
        case 'left':
          left = triggerBounding.left;
          break;
        case 'right':
          left = triggerBounding.left - width + triggerBounding.width;
          break;
        default:
      }
      let startName;
      let lengthName;
      let start;
      let length;
      if (['top', 'bottom'].includes(positionPrimary)) {
        /* Check if left needs adjusted due to overflowing wrapperBox */
        adjusted = Math.min(wrapperBox.left + wrapperBox.width - (left + width), 0); // Shift left if overflowing wrapperBox right
        adjusted += Math.max(wrapperBox.left - (left + adjusted), 0); // Then shift right if overflowing left
        left += adjusted;
        startName = 'left';
        lengthName = 'width';
        start = left;
        length = width;
      } else if (['left', 'right'].includes(positionPrimary)) {
        /* Check if top needs adjusted due to overflowing wrapperBox */
        adjusted = Math.min(wrapperBox.top + wrapperBox.height - (top + height), 0); // Shift up if overflowing wrapperBox bottom
        adjusted += Math.max(wrapperBox.top - (top + adjusted), 0); // Then shift down if overflowing top
        top += adjusted;
        startName = 'top';
        lengthName = 'height';
        start = top;
        length = height;
      }

      /* eslint-disable max-len */
      arrowPosition[startName] = "".concat(triggerBounding[startName] + triggerBounding[lengthName] / 2 > start + length - (arrowRadius + arrowMarginEnd) ? triggerBounding[startName] + triggerBounding[lengthName] * 0.2 < start + length * 0.86 - 1 && length * 0.86 - 1 < length - (arrowRadius + arrowMarginEnd) ? length * 0.86 - 1 : length - (arrowRadius + arrowMarginEnd) : triggerBounding[startName] + triggerBounding[lengthName] / 2 < start + arrowRadius + arrowMarginStart ? triggerBounding[startName] + triggerBounding[lengthName] * 0.8 > start + length * 0.14 - 1 && length * 0.14 - 1 > arrowRadius + arrowMarginEnd ? length * 0.14 - 1 : arrowRadius + arrowMarginStart : triggerBounding[startName] + triggerBounding[lengthName] / 2 - start, "px");
      /* eslint-enable max-len */

      top = positionPrimary === 'top' ? top - offsetY : top + offsetY;
      left = positionPrimary === 'left' ? left - offsetX : left + offsetX;
      arrowShadow = arrowShadow.concat(' 1px 0 #bababca1');
      const arrowTop = arrowPosition.top;
      const arrowLeft = arrowPosition.left;
      return {
        top,
        left,
        arrowTop,
        arrowLeft,
        arrowShadow,
        adjusted
      };
    };
    this.calculatePosition = (triggerBounding, contentBounding, positions, _ref2, wrapperBox) => {
      let {
        offsetX,
        offsetY
      } = _ref2;
      let bestCoords;
      let i = 0;
      while (i < positions.length) {
        const tryCoords = this.getCoordinatesForPosition(triggerBounding, contentBounding, positions[i], {
          offsetX,
          offsetY
        }, wrapperBox);
        const contentBox = {
          top: tryCoords.top,
          left: tryCoords.left,
          width: contentBounding.width,
          height: contentBounding.height,
          adjusted: tryCoords.adjusted
        };
        if (contentBox.top <= wrapperBox.top || contentBox.left <= wrapperBox.left || contentBox.top + contentBox.height >= wrapperBox.top + wrapperBox.height || contentBox.left + contentBox.width >= wrapperBox.left + wrapperBox.width) {
          if (!bestCoords) bestCoords = {
            ...tryCoords,
            overflow: true
          };
          i += 1;
        } else if (contentBox.adjusted) {
          if (!bestCoords || bestCoords.overflow) bestCoords = tryCoords;
          i += 1;
        } else {
          bestCoords = tryCoords;
          break;
        }
      }
      return bestCoords;
    };
    this.handleCustomScrollListener = () => {
      handleScroll(this, () => this.setPosition());
    };
    this.setPosition = () => {
      // log.trace('setting position');
      const {
        modal,
        isOpen
      } = this.state;
      if (modal || !isOpen || !this.TriggerEl || !this.ContentEl) return;
      const {
        arrow,
        position,
        offsetX,
        offsetY,
        keepTooltipInside,
        arrowStyle
      } = this.props;
      this.ContentEl.style.top = 0; // Initialize top to 0 to calculate offset
      this.ContentEl.style.left = 0; // Initialize left to 0 to calculate offset
      const trigger = this.TriggerEl.getBoundingClientRect();
      const content = this.ContentEl.getBoundingClientRect();
      const boundingBox = this.getTooltipBoundary();
      const baseOffset = {
        top: content.top,
        left: content.left
      };
      let positions = Array.isArray(position) ? position : [position];
      if (keepTooltipInside) positions = [...positions, ...POSITION_TYPES];
      const coords = this.calculatePosition(trigger, content, positions, {
        offsetX,
        offsetY
      }, boundingBox);
      this.ContentEl.style.top = "".concat(coords.top - baseOffset.top, "px");
      this.ContentEl.style.left = "".concat(coords.left - baseOffset.left, "px");
      if (arrow && this.ArrowEl) {
        this.ArrowEl.style.top = arrowStyle.top || coords.arrowTop;
        this.ArrowEl.style.left = arrowStyle.left || coords.arrowLeft;
        this.ArrowEl.boxShadow = arrowStyle.boxShadow || coords.arrowShadow;
        this.ArrowEl.style['-ms-box-shadow'] = arrowStyle.boxShadow || coords.arrowShadow;
        this.ArrowEl.style['-webkit-box-shadow'] = arrowStyle.boxShadow || coords.arrowShadow;
      }

      // log.trace(
      //     '//// popup position info:',
      //     {
      //         trigger,
      //         content,
      //         boundingBox,
      //         positions,
      //         baseOffset,
      //         coords,
      //         'this.ContentEl.style:': this.ContentEl.style,
      //     },
      // );
    };
    this.prompt = params => {
      // log.trace('prompted. isOpen:', isOpen);
      this.promptIndex += 1;
      const indexRef = this.promptIndex;
      const {
        content,
        hold = 1000,
        blink
      } = params || {};
      const {
        isOpen
      } = this.state;
      // log.trace('prompting popup. content:', content, 'hold:', hold);

      this.setState({
        promptMessage: content
      });
      if (blink) {
        /* If already open but content changed, make popup blink by closing and reopening */
        const contentComputed = this.computeContent();
        const contentStaticMarkupComputed = ReactDOMServer.renderToStaticMarkup(contentComputed);
        // log.trace('contentStaticMarkupComputed:', contentStaticMarkupComputed);
        // log.trace('this.contentStaticMarkup:', this.contentStaticMarkup);
        if (isOpen && this.contentStaticMarkup !== contentStaticMarkupComputed) {
          log.trace('blinking...');
          this.prompted = false;
          this.closePopup();
          this.prompted = true;
          setTimeout(() => {
            if (this.mounted) this.openPopup();
          }, 100);
        } else {
          this.prompted = true;
          this.openPopup();
        }
        this.contentStaticMarkup = contentStaticMarkupComputed;
      } else {
        this.prompted = true;
        this.openPopup();
      }
      setTimeout(() => {
        if (this.promptIndex === indexRef && this.mounted) {
          this.prompted = false;
          this.closePopup();
        }
      }, hold);
    };
    this.addWarperAction = () => {
      const {
        style,
        className,
        on,
        wide
      } = this.props;
      const {
        modal
      } = this.state;
      const childrenElementProps = {
        className: 'enjoyPopup'.concat(modal ? ' modal' : '').concat(wide ? ' wide' : '').concat(className ? " ".concat(className) : ''),
        style: Object.assign({}, style),
        ref: this.setContentRef,
        onClick: e => {
          e.stopPropagation();
        }
      };
      // log.trace('childrenElementProps:', childrenElementProps);
      if (!modal && on.includes('hover')) {
        childrenElementProps.onMouseEnter = this.onMouseEnter;
        childrenElementProps.onMouseLeave = this.onMouseLeave;
      }
      return childrenElementProps;
    };
    this.renderTrigger = () => {
      const triggerProps = {
        key: 'T',
        ref: this.setTriggerRef
      };
      const {
        on,
        trigger,
        closeOnClickAway
      } = this.props;
      const {
        isOpen
      } = this.state;
      const onAsArray = Array.isArray(on) ? on : [on];
      for (let i = 0, len = onAsArray.length; i < len; i++) {
        switch (onAsArray[i]) {
          case 'click':
            triggerProps.onClick = this.togglePopup;
            break;
          case 'hover':
            triggerProps.onMouseEnter = this.onMouseEnter;
            triggerProps.onMouseLeave = this.onMouseLeave;
            break;
          case 'focus':
            triggerProps.onFocus = this.onMouseEnter;
            break;
          default:
        }
      }
      const openOnClick = on === 'click' || Array.isArray(on) && on.includes('click');
      if (!openOnClick && closeOnClickAway) triggerProps.onClick = this.preventPopupClose;
      const triggerComponent = React.cloneElement(typeof trigger === 'function' ? trigger(isOpen) : trigger, triggerProps);
      return !!trigger && triggerComponent;
    };
    this.computeContent = () => {
      const {
        children,
        content
      } = this.props;
      const {
        promptMessage
      } = this.state;
      const contentComputed = promptMessage !== undefined ? promptMessage : children || content;
      return contentComputed;
    };
    this.renderContent = () => {
      const {
        arrow,
        arrowStyle,
        scrollListener: scrollListenerProp
      } = this.props;
      const {
        isOpen,
        modal
      } = this.state;
      const open = isOpen && !modal;
      if (!open) {
        if (this.scrollListener) this.scrollListener.removeEventListener('scroll', this.handleCustomScrollListener);
        return null;
      }
      const content = this.computeContent();
      if (!content) {
        throw new Error('No content or children supplied to Popup component');
      }
      let scrollListener;
      if (scrollListenerProp) {
        if (scrollListenerProp.current) scrollListener = scrollListenerProp.current;else if (scrollListenerProp.nodeName) scrollListener = scrollListenerProp;
        // log.trace('scrollListener:', scrollListener, 'scrollListenerProp:', scrollListenerProp);
      }
      if (scrollListener) {
        if (this.scrollListener) this.scrollListener.removeEventListener('scroll', this.handleCustomScrollListener);
        this.scrollListener = scrollListener;
        this.scrollListener.addEventListener('scroll', this.handleCustomScrollListener);
      }
      // log.trace('show arrow:', arrow);
      return /*#__PURE__*/React.createElement("div", Object.assign({}, this.addWarperAction(), {
        key: "C"
      }), arrow && /*#__PURE__*/React.createElement("div", {
        className: "popup-arrow",
        ref: this.setArrowRef,
        style: Object.assign({}, arrowStyle)
      }), typeof content === 'function' ? content(this.closePopup, isOpen) : content);
    };
    const {
      open: _open,
      modal: _modal,
      defaultOpen,
      trigger: _trigger
    } = props;
    this.state = {
      isOpen: _open !== undefined ? _open : Boolean(defaultOpen),
      promptMessage: undefined,
      /* We create a modal state because the popup can't be a tooltip if the trigger prop doesn't exist: */
      modal: _modal ? true : !_trigger
      // mountNode: null,
    };
    this.timeOut = 0;
    this.popupClick = false;
    this.prompted = false;
    this.promptIndex = 0;
    this.contentStaticMarkup = '';
    this.mounted = false;
  }
  componentDidMount() {
    const {
      closeOnEscape,
      repositionOnResize,
      prompt
    } = this.props;
    // if (this.state.isOpen) this.setPosition(); // Call on ref initialization instead
    if (closeOnEscape) {
      window.addEventListener('keyup', this.onEscape);
    }
    if (repositionOnResize) {
      window.addEventListener('resize', this.handleResize);
    }
    this.mounted = true;
    prompt(this.prompt); // Pass this.prompt to parent
  }
  componentDidUpdate(prevProps, prevState) {
    // log.trace('previous:', { prevProps, prevState });
    const {
      open,
      disabled,
      children,
      content
    } = this.props;
    const {
      isOpen,
      promptMessage
    } = this.state;
    const openComputed = (open !== undefined ? open : isOpen) && !disabled;
    if (isOpen !== openComputed) {
      if (open) this.openPopup();else this.closePopup();
    }

    /* Update position if content changes */
    if (ReactDOMServer.renderToStaticMarkup(children) !== ReactDOMServer.renderToStaticMarkup(prevProps.children) || ReactDOMServer.renderToStaticMarkup(content) !== ReactDOMServer.renderToStaticMarkup(prevProps.content) || ReactDOMServer.renderToStaticMarkup(promptMessage) !== ReactDOMServer.renderToStaticMarkup(prevState.promptMessage)) {
      this.setPosition();
    }

    // if (prevProps.open !== open && !disabled) {
    //     if (open) this.openPopup();
    //     else this.closePopup();
    // } else if (prevProps.disabled !== disabled && disabled && isOpen) {
    //     this.closePopup();
    // }
  }
  componentWillUnmount() {
    // kill any function to execute if the component is unmounted
    clearTimeout(this.timeOut);
    const {
      closeOnEscape,
      repositionOnResize
    } = this.props;
    // remove events listeners
    if (closeOnEscape) {
      window.removeEventListener('keyup', this.onEscape);
    }
    if (repositionOnResize) {
      window.removeEventListener('resize', this.handleResize);
    }
    if (this.TriggerEl) this.TriggerEl.removeEventListener('click', this.handleTriggerClicked);
    if (this.scrollListener) this.scrollListener.removeEventListener('scroll', this.handleCustomScrollListener);
    window.removeEventListener('click', this.handleClickAway);
    this.resetScroll();
    this.mounted = false;
  }
  render() {
    // const { mountNode } = this.state;
    const {
      mountNode: mountNodeProp
    } = this.props;
    const triggerComponent = this.renderTrigger();
    const popupContent = this.renderContent();
    let mountNode;
    if (mountNodeProp) {
      if (mountNodeProp.current) mountNode = mountNodeProp.current;else if (mountNodeProp.nodeName) mountNode = mountNodeProp;
    }
    if (!mountNode) mountNode = (this.TriggerEl || {}).parentElement || document.body;
    return /*#__PURE__*/React.createElement(React.Fragment, null, triggerComponent, /* mountNode && */ReactDOM.createPortal(popupContent, mountNode));
  }
}
Popup.defaultProps = {
  trigger: null,
  onOpen: () => {},
  onClose: () => {},
  defaultOpen: false,
  open: undefined,
  disabled: false,
  // closeOnDocumentClick: true,
  closeOnClickAway: true,
  repositionOnResize: true,
  closeOnEscape: true,
  on: ['hover'],
  style: {},
  arrowStyle: {},
  // overlayStyle: {},
  className: '',
  position: 'bottom center',
  wide: false,
  modal: false,
  lockScroll: false,
  arrow: true,
  offsetX: 0,
  offsetY: 0,
  mouseEnterDelay: 100,
  mouseLeaveDelay: 100,
  mountNode: null,
  keepTooltipInside: false,
  prompt: () => null,
  scrollListener: null
};